function escapeHtml(value) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function sanitizeUrl(url) {
  if (/^(https?:\/\/|mailto:)/i.test(url)) {
    return url;
  }

  return "#";
}

function formatInlineRichText(value) {
  let formatted = escapeHtml(value);

  formatted = formatted.replace(
    /\[([^\]]+)\]\(([^)\s]+)\)/g,
    (_, label, url) =>
      `<a href="${sanitizeUrl(url)}" target="_blank" rel="noopener noreferrer">${label}</a>`,
  );
  formatted = formatted.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
  formatted = formatted.replace(/__(.+?)__/g, "<strong>$1</strong>");
  formatted = formatted.replace(/\*(.+?)\*/g, "<em>$1</em>");
  formatted = formatted.replace(/_(.+?)_/g, "<em>$1</em>");
  formatted = formatted.replace(/~~(.+?)~~/g, "<del>$1</del>");
  formatted = formatted.replace(/`(.+?)`/g, "<code>$1</code>");

  return formatted;
}

export function formatRichText(value, options = {}) {
  const input = String(value || "").trim();

  if (!input) {
    return "";
  }

  if (options.multiline === false) {
    return formatInlineRichText(input);
  }

  return input
    .split(/\n{2,}/)
    .map((paragraph) => `<p>${formatInlineRichText(paragraph).replace(/\n/g, "<br />")}</p>`)
    .join("");
}

export function stripRichText(value) {
  return String(value || "")
    .replace(/\[([^\]]+)\]\(([^)\s]+)\)/g, "$1")
    .replace(/(\*\*|__|\*|_|~~|`)/g, "")
    .replace(/\s+/g, " ")
    .trim();
}
